import React, { useState } from 'react';
import { fetchInviteesForCSV } from '../../../shared/utils/api';
import moment from 'moment';
import BeatLoader from 'react-spinners/BeatLoader';
import { camelizeKeys } from 'humps';

const CSVDownloader = ({ slug, setFeedback }) => {
  const [isLoading, setIsLoading] = useState(false);

  const downloadCSV = async () => {
    setIsLoading(true);

    try {
      const response = await fetchInviteesForCSV(slug);
      let csv = 'First Name,Last Name,Email,Title,Company,Invited Created Date,Invite Status,Status Updated Date\n';

      const { invites } = response.data;
      invites.forEach(function (item) {
        item = camelizeKeys(item);
        csv += `"${item.firstName}","${item.lastName}","${item.email}","${item.title}","${item.company}","${item.inviteCreatedAt}","${item.inviteStatus}","${item.inviteStatusUpdatedAt}"\n`;
      });

      let blob = new Blob([csv], { type: 'text/csv;encoding:utf-8' });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `invited_guests_${slug}_${moment().calendar(
        'DD/MM/YYYY'
      )}`;
      link.click();
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.log('Error downloading CSV:', error);
      setFeedback({
        type: 'download',
        msg: 'There was a problem downloading CSV',
      });
    }

    setIsLoading(false);
  };

  return (
    <button className='btn-main' onClick={downloadCSV}>
      {isLoading ? (
        <BeatLoader
          color='#3d898b'
          speedMultiplier={0.5}
          size={10}
          margin={0}
        />
      ) : (
        'Download CSV'
      )}
    </button>
  );
};

export default CSVDownloader;
